import { jsonpRequest } from '../../utils/jsonp';

const API_KEY = process.env.REACT_APP_VWORLD_API_KEY || '';

export interface VWorldSearchItem {
  id: string;
  address: {
    zipcode: string;
    category: string;
    road: string;
    parcel: string;
    bldnm: string;
  };
  point: {
    x: string;
    y: string;
  };
}

export interface VWorldSearchResponse {
  service: {
    name: string;
    version: string;
    operation: string;
    time: string;
  };
  status: string;
  record: {
    total: string;
    current: string;
  };
  page: {
    total: string;
    current: string;
    size: string;
  };
  result: {
    crs: string;
    type: string;
    items: VWorldSearchItem[];
  };
}

/**
 * VWorld Search API를 사용하여 주소 목록을 검색합니다.
 * @param query 검색할 주소
 * @param page 페이지 번호 (1부터 시작)
 * @param size 페이지당 항목 수 (기본값: 30)
 * @returns VWorld Search API 응답
 */
export const searchAddressList = async (
  query: string,
  page: number = 1,
  size: number = 30,
): Promise<VWorldSearchResponse> => {
  const params = {
    service: 'search',
    request: 'search',
    version: '2.0',
    crs: 'EPSG:4326',
    size: size.toString(),
    page: page.toString(),
    query,
    type: 'ADDRESS',
    category: 'PARCEL',
    format: 'json',
    key: API_KEY,
  };

  try {
    const response = await jsonpRequest('https://api.vworld.kr/req/search', params);

    if (response.response?.status !== 'OK') {
      throw new Error('주소 검색에 실패했습니다.');
    }

    return response.response;
  } catch (error) {
    console.error('❌ VWorld 주소 검색 실패:', error);
    throw error;
  }
};
